// 引入axios
import axios from "axios";
import store from "@/store/index";
import router from "@/router";
// 引入ElMessage模块，toast提示
import { ElMessage } from "element-plus";
// 引入storage模块，操作token
import { Key, Cookie } from "@/utils/storage/cookie";
import BASE_URL from "../../public/static/config.json";

// 请求超时时间
axios.defaults.timeout = 600000;

const longTaskApi = axios.create({
  baseURL: BASE_URL.baseURL,
  timeout: 600000*10,
  headers: { 'Content-Type': 'application/json' }
});



// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 代理拼接
    config.url = BASE_URL.baseURL + config.url;
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    if (config.url != "/login" && config.url != "/loginout") {
      if (window.location.pathname == "/BookSearchs" || window.location.pathname == "/BookRetrieval") {
        const OpacToken = Cookie.get(Key.OpacToken);
        OpacToken && (config.headers["Opac-Authorization"] = OpacToken);
      } else {
        const token = Cookie.get(Key.token);
        token && (config.headers["Jwt-Authorization"] = token);
      }
    }

    // if (config.method.toUpperCase() === "POST") {
    //   config.headers["Content-Type"] = "application/json;charset=utf-8";
    // }
    return config;
  },
  (error) => {
    // console.log("*-----------111111111111--------------------"+response)
    return Promise.error(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (window.location.pathname == "/BookSearchs" || window.location.pathname == "/BookRetrieval") {
      if (response.headers.get("Opac-Authorization") != undefined) {
        const token = response.headers.get("Opac-Authorization");
        Cookie.set(Key.OpacToken, token);
      }
    } else {
      //需要颁发新的token,用于动态延长token 的有效期。
      if (response.headers.get("Jwt-Authorization") != undefined) {
        const token = response.headers.get("Jwt-Authorization");
        Cookie.set(Key.token, token);
      }
    }

    if (response.status === 200) {
      // token过期
      if (response.data.status == 101) {
        store.dispatch("resetState");
        //OPAC 页面超时清除opactoken
        if (window.location.pathname == "/BookSearchs" || window.location.pathname == "/BookRetrieval") {
          Cookie.remove(Key.OpacToken);
          ElMessage.warning(response.data.message || response.data.msg);
          router.push({ path: "/login" });
        } else {
          //PC后台页面超时清除token
          Cookie.remove(Key.token);
          ElMessage.warning(response.data.message || response.data.msg);
          router.push({ path: "/login" });
        }

        //OPAC端登录账号重复被踢出状态
      } else if (response.data.status == 103) {
        store.dispatch("resetState");
        Cookie.remove(Key.OpacToken);
        ElMessage.warning(response.data.message || response.data.msg);
        router.push({ path: "/excption/403" });
        //PC 端登录账号重复被踢出状态
      } else if (response.data.status == 104) {
        store.dispatch("resetState");
        Cookie.remove(Key.token);
        ElMessage.warning(response.data.message || response.data.msg);
        router.push({ path: "/login" });
      } else if (response.data.status == 401) {
        store.dispatch("resetState");
        Cookie.remove(Key.token);
        Cookie.remove(Key.OpacToken);
        ElMessage.warning(response.data.message || response.data.msg);
        router.push({ path: "/login" });
        //接口没有权限
      } else if (response.data.status == 405) {
        ElMessage.warning(response.data.message || response.data.msg);
        return Promise.resolve(response);
        //token 解析异常
      } else if (response.data.status == 102) {
        Cookie.remove(Key.token);
        Cookie.remove(Key.OpacToken);
        ElMessage.warning(response.data.message || response.data.msg);
        router.push({ path: "/login" });
      } else if (
        (response.data.status && response.data.status == "001") ||
        (response.data.code && response.data.code == "001")
      ) {
        return Promise.resolve(response);
      } else if (
        (response.data.status && response.data.status != 200) ||
        (response.data.code && response.data.code != 200)
      ) {
        ElMessage.warning(response.data.message || response.data.msg);
        return Promise.resolve(response);
      } else {
        return Promise.resolve(response);
      }
    } else {
      ElMessage.error(response.data.message || response.data.msg);
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 500:
          ElMessage.error("系统异常，请稍后再试！");
          break;
        case 404:
          ElMessage.error("网络错误，请稍后再试！");
          break;
        // 其他错误，直接抛出错误提示
        default:
          if (error.response.data.message || error.response.data.msg) {
            ElMessage.error(
              error.response.data.message || error.response.data.msg
            );
          }
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
// 设置超时更长的post方法，对应post请求
export function longTaskPost(url, params) {
   return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
  timeout: 600000*10, 
 
})
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * 
 */
export function uploadFile(url, formData, onProgress) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData, {
        headers: {
            timeout: 600000*10, 
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          console.log('上传进度：uploadFile', progressEvent);
          if (progressEvent.upload) {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            console.log('上传进度：uploadFile', progress);
            onProgress(progress);
          }
        },
      })
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        reject(error.response.data || error.message); 
      });
  });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function remove(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response.data);
      });
  });
}

/**
 * get方法，对应get请求,直接在地址后面拼串的形式
 * @param {String} url [请求的url地址]
 * @param {String} params [请求时携带的参数]
 */
export function getDynamicynamic(url, params) {
  return new Promise((resolve, reject) => {
    const completeUrl = `${url}/${params}`;
    axios
      .get(completeUrl, {})
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * get方法，对应get请求,直接在地址后面拼串的形式
 * @param {String} url [请求的url地址]
 * @param {String} params [请求时携带的参数]
 */
export function getinfo(url, params) {
  return new Promise((resolve, reject) => {
    const completeUrl = `${url}${params}`;
    axios
      .get(completeUrl, {})
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，导出文件
 * @param {String} url [请求的url地址]
 * @param {String} params [请求时携带的参数]
 */
export function getFileUseBlobByPost(url, params ) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      data: params,
      responseType: "blob",
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * POST方式导出文件并保留响应头，供页面读取后端文件名。
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @returns {Promise<Object>} 包含文件数据和响应头的完整响应
 */
export function getFileResponseByPost(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      data: params,
      responseType: "blob",
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * 登录
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function loginApi(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，导出文件
 * @param {String} url [请求的url地址]
 * @param {String} params [请求时携带的参数]
 */
export function getLongFileUseBlobByPost(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url,
      timeout: 900000,
      data: params,
      responseType: "blob",
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
